import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { TSType } from '../models'
import { IFieldProps } from '../models/IFieldProps'

import { getFieldName } from './getFieldName'

export const setItemValues = (
  item: IJBPPlanningItem,
  value: string | number | null,
  fieldProps: IFieldProps,
  category: string,
  isManual: boolean,
  translationFactors?: ITranslationFactors[] | null,
  sTypeOriginal?: TSType
): IJBPPlanningItem => {
  const fieldName = getFieldName(fieldProps)

  // Maximum Fraction Digits: 1 for SoB and 0 for Values
  const digits = fieldProps.isSoB ? 1 : 0
  const numValue = value || value === 0 ? Number(Number(value).toFixed(digits)) : null

  const isChanged = fieldProps.isSoB ? item.IsChanged : 1
  const isChangedSoB = fieldProps.isSoB ? 1 : item.IsChangedSoB
  // Optional additional field (no in IJBPPlanningItem)
  const isChangedUnits = fieldProps.isUnits ? 1 : 0

  const sTypeFixed = sTypeOriginal ?? fieldProps.sType

  const isChangedSoBManual = isManual
    ? item.IsChangedSoBManual || isChangedSoB
    : item.IsChangedSoBManual

  // TODO: Add && !isChangedSoB ?
  const isChangedManual =
    isManual && !isChangedUnits && !sTypeFixed
      ? item.IsChangedManual || isChanged
      : item.IsChangedManual
  const isChangedContractualManual =
    isManual && !isChangedUnits && sTypeFixed == 'c'
      ? item.IsChangedContractualManual || isChanged
      : item.IsChangedContractualManual
  const isChangedTransactionalManual =
    isManual && !isChangedUnits && sTypeFixed == 't'
      ? item.IsChangedTransactionalManual || isChanged
      : item.IsChangedTransactionalManual

  // TODO: Add && !isChangedSoB ?
  const isChangedUnitsManual =
    isManual && isChangedUnits && !sTypeFixed
      ? item.IsChangedUnitsManual || isChangedUnits
      : item.IsChangedUnitsManual
  const isChangedUnitsContractualManual =
    isManual && isChangedUnits && sTypeFixed == 'c'
      ? item.IsChangedUnitsContractualManual || isChangedUnits
      : item.IsChangedUnitsContractualManual
  const isChangedUnitsTransactionalManual =
    isManual && isChangedUnits && sTypeFixed == 't'
      ? item.IsChangedUnitsTransactionalManual || isChangedUnits
      : item.IsChangedUnitsTransactionalManual

  let newItem: IJBPPlanningItem = {
    ...item,

    [fieldName]: numValue,

    IsChanged: isChanged,
    IsChangedSoB: isChangedSoB,
    //IsChangedUnits: isChangedUnits,

    IsChangedSoBManual: isChangedSoBManual,

    IsChangedManual: isChangedManual,
    IsChangedContractualManual: isChangedContractualManual,
    IsChangedTransactionalManual: isChangedTransactionalManual,

    IsChangedUnitsManual: isChangedUnitsManual,
    IsChangedUnitsContractualManual: isChangedUnitsContractualManual,
    IsChangedUnitsTransactionalManual: isChangedUnitsTransactionalManual,
  }

  const factors = translationFactors?.filter((el) => el.Category === category)

  //
  // TODO: Remove this code after translationFactors will be changes to include all factors for all types
  //
  const isNdp = fieldProps.actualsType === ActualsValueTypes.Ndp

  if (!fieldProps.isSoB && factors && factors.length) {
    if (fieldProps.isUnits) {
      const ndpUnitsField = getFieldName({ ...fieldProps, actualsType: ActualsValueTypes.Ndp })
      const netUnitsField = getFieldName({ ...fieldProps, actualsType: ActualsValueTypes.Net })

      newItem = {
        ...newItem,

        // Units fields has the same Value for Ndp and Net
        [ndpUnitsField]: numValue,
        [netUnitsField]: numValue,
      }
    } else {
      const ndpUSDField = getFieldName({
        ...fieldProps,
        actualsType: ActualsValueTypes.Ndp,
        currency: 'USD',
      })
      const netUSDField = getFieldName({
        ...fieldProps,
        actualsType: ActualsValueTypes.Net,
        currency: 'USD',
      })
      const ndpLCField = getFieldName({
        ...fieldProps,
        actualsType: ActualsValueTypes.Ndp,
        currency: 'LC',
      })
      const netLCField = getFieldName({
        ...fieldProps,
        actualsType: ActualsValueTypes.Net,
        currency: 'LC',
      })

      const isUSD = !fieldProps.currency || fieldProps.currency === 'USD'

      if (isUSD) {
        const ndpUSDNet =
          numValue || numValue === 0
            ? Number((numValue * (factors[0].NdpToNet || 1)).toFixed(digits))
            : null
        const ndpUSD = isNdp ? numValue : ndpUSDNet

        const netUSDNdp =
          numValue || numValue === 0
            ? Number((numValue * (factors[0].NetToNdp || 1)).toFixed(digits))
            : null
        const netUSD = isNdp ? netUSDNdp : numValue

        const ndpLCNdp =
          numValue || numValue === 0
            ? Number((numValue * (factors[0].LCToUsd || 1)).toFixed(digits))
            : null
        const ndpLCNet =
          numValue || numValue === 0
            ? Number(
                (numValue * (factors[0].LCToUsd || 1) * (factors[0].NdpToNet || 1)).toFixed(digits)
              )
            : null
        const ndpLC = isNdp ? ndpLCNdp : ndpLCNet

        const netLCNdp =
          numValue || numValue === 0
            ? Number(
                (numValue * (factors[0].LCToUsd || 1) * (factors[0].NetToNdp || 1)).toFixed(digits)
              )
            : null
        const netLCNet =
          numValue || numValue === 0
            ? Number((numValue * (factors[0].LCToUsd || 1)).toFixed(digits))
            : null
        const netLC = isNdp ? netLCNdp : netLCNet

        newItem = {
          ...newItem,

          [ndpUSDField]: ndpUSD,
          [netUSDField]: netUSD,
          [ndpLCField]: ndpLC,
          [netLCField]: netLC,
        }
      } else {
        const ndpUSDNdp =
          numValue || numValue === 0
            ? Number((numValue * (factors[0].UsdToLC || 1)).toFixed(digits))
            : null
        const ndpUSDNet =
          numValue || numValue === 0
            ? Number(
                (numValue * (factors[0].UsdToLC || 1) * (factors[0].NdpToNet || 1)).toFixed(digits)
              )
            : null
        const ndpUSD = isNdp ? ndpUSDNdp : ndpUSDNet

        const netUSDNdp =
          numValue || numValue === 0
            ? Number(
                (numValue * (factors[0].UsdToLC || 1) * (factors[0].NetToNdp || 1)).toFixed(digits)
              )
            : null
        const netUSDNet =
          numValue || numValue === 0
            ? Number((numValue * (factors[0].UsdToLC || 1)).toFixed(digits))
            : null
        const netUSD = isNdp ? netUSDNdp : netUSDNet

        const ndpLCNet =
          numValue || numValue === 0
            ? Number((numValue * (factors[0].NdpToNet || 1)).toFixed(digits))
            : null
        const ndpLC = isNdp ? numValue : ndpLCNet

        const netLCNdp =
          numValue || numValue === 0
            ? Number((numValue * (factors[0].NetToNdp || 1)).toFixed(digits))
            : null
        const netLC = isNdp ? netLCNdp : numValue

        newItem = {
          ...newItem,

          [ndpUSDField]: ndpUSD,
          [netUSDField]: netUSD,
          [ndpLCField]: ndpLC,
          [netLCField]: netLC,
        }
      }
    }
  }

  return newItem
}
